module.exports = __webpack_public_path__ + "img/dj.2c89539d.svg";